<ng-container *ngIf="transactions$ | async as transactions">
  <!-- Empty state -->
  <section class="tab-empty-state" *ngIf="!transactions || transactions.length === 0">
    <img src="assets/images/general/empty_state.svg"/>
    <h2>No transactions yet</h2>
  </section>

  <div class="flex pt-3">
    <ng-container *ngIf="(investingEntities$ | async) as investingEntities">
      <terra-lp-asset-filter class="entities-filter" [items]="investingEntities" (onFilter)="filter($event)"></terra-lp-asset-filter>
    </ng-container>

    <button type="button" [disabled]="isGeneratingExportFile$ | async" (click)="export()"
            *ngIf="transactions && transactions.length > 0" class="export-button">
      <mat-icon class="notranslate">download</mat-icon>
      EXPORT ALL
      <terra-loader *ngIf="isGeneratingExportFile$ | async"></terra-loader>
    </button>
  </div>

  <ul class="transactions-list">
    <li *ngFor="let transaction of transactions" (click)="isClickableTransaction(transaction) && showBreakdownDialog(transaction)"
        [ngClass]="{'popup': isClickableTransaction(transaction)}">
      <div class="transaction-icon-div">
        <mat-icon *ngIf="transaction.isOutgoing" svgIcon="transaction_outgoing"
                  class="notranslate transaction-icon outgoing-icon">
        </mat-icon>
        <mat-icon *ngIf="!transaction.isOutgoing" svgIcon="transaction_incoming"
                  class="notranslate transaction-icon incoming-icon">
        </mat-icon>
        <span class="icon-label">{{transaction.isOutgoing ? 'Contribution' : 'Distribution'}}</span>
      </div>
      <div class="transaction-left">
        <div *ngIf="transaction.isOutgoing" class="transaction-name">{{transaction.transactionName}}</div>
        <div *ngIf="!transaction.isOutgoing" class="transaction-name">Distribution
          - {{transaction.transactionName}}</div>
        <div class="transaction-date">{{transaction.date | date}}</div>

        <div *ngIf="transaction.isOutgoing" class="investing-entity-name lo_sensitive">
          via: {{ transaction.investingEntityName }}</div>
        <div *ngIf="!transaction.isOutgoing" class="investing-entity-name lo_sensitive">
          to: {{ transaction.investingEntityName }}</div>
      </div>
      <div class="transaction-right">
        <div>{{ getCurrency(transaction).symbol }}{{((getAmountAsync(transaction) | async) | terraCurrency) || 0 }} {{ getCurrency(transaction).iso | hideUsdIso }}</div>
        <div class="transaction-status">{{TransactionStatus.toString(transaction.status)}}</div>
        <div *ngIf="!transaction.isOutgoing">{{ transaction.distributionType === DistributionType.MultiType ? 'Return' : transaction.distributionType | enumString:DistributionType }}</div>
      </div>
      <div class="transaction-right-icon-div">
        <mat-icon *ngIf="isClickableTransaction(transaction)" class="arrow-icon notranslate">chevron_right</mat-icon>
      </div>
    </li>
  </ul>
</ng-container>
